import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "products-carousel__header" }
const _hoisted_2 = { class: "products-carousel__header-title" }

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

import useWindowResize from '@/composables/useWindowResize';
import useContext from '@/composables/useContext';
import useProductsCarouselBlock from '@/composables/useProductsCarouselBlock';

import Tabs from '../components/Tabs.vue';
import ProductsCarouselV2 from '@/components/ProductsCarousel/ProductsCarouselV2.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsCarousel',
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "6389e907": (_unref(headerAlignment))
}))



const options = {
  setProducts,
  numProducts: props.block?.fields?.NumberOfProducts || 10,
};

const { registerProductBlockTab, unregisterProductBlockTab } =
  useProductsCarouselBlock(options);

const { page } = useContext();
const { isMobile } = useWindowResize();

const selectedTabProducts = ref<any[]>([]);
const title = computed(() => props.block.fields?.Title || '');
const marginTop = computed(() => props.block.fields.MarginTop);
const marginBottom = computed(() => props.block.fields.MarginBottom);

const tabs = computed(() => props.block.fields?.DataSource || []);

const tabsNames = computed(() => tabs.value.map((d) => d.tabName));
const activeTabName = ref(tabsNames.value[0]);

const selectedTab = computed(() => {
  return tabs.value.find((tab) => tab.tabName === activeTabName.value);
});

const headerAlignment = computed(() =>
  page.value?.type === 'Category' ? 'center' : 'start'
);

function setProducts(parentProducts: any[]) {
  selectedTabProducts.value = parentProducts;
}

const updateActiveTab = (newTabName: string) => {
  const oldTabId = selectedTab.value.tabCategorySystemId;
  activeTabName.value = newTabName;

  const newTabId = tabs.value.find(
    (tab) => tab.tabName === newTabName
  ).tabCategorySystemId;

  selectedTabProducts.value = [];
  registerProductBlockTab(props.block, newTabId);
  unregisterProductBlockTab(props.block, oldTabId);
};

onMounted(() => {
  registerProductBlockTab(props.block, selectedTab.value.tabCategorySystemId);
});

onBeforeUnmount(() => {
  props.block.fields.DataSource.forEach((tab) => {
    unregisterProductBlockTab(props.block, tab.tabCategorySystemId);
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "products-carousel-block",
    style: _normalizeStyle({ marginTop: _unref(marginTop), marginBottom: _unref(marginBottom) })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(title)), 1),
      (_unref(selectedTab)?.buttonText && !_unref(isMobile))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _unref(selectedTab).tabLink,
            class: "products-carousel__header-action"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(selectedTab)?.buttonText), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Tabs, {
      activeTabName: activeTabName.value,
      tabs: _unref(tabsNames),
      "onUpdate:activeTabName": updateActiveTab,
      class: "products-carousel__tabs"
    }, _createSlots({ _: 2 }, [
      _renderList(_unref(tabsNames), (tab) => {
        return {
          name: tab,
          fn: _withCtx(() => [
            (_openBlock(), _createBlock(ProductsCarouselV2, {
              class: "products-carousel__carousel",
              key: tab,
              products: selectedTabProducts.value,
              "margin-top": _unref(marginTop),
              "margin-bottom": _unref(marginBottom)
            }, null, 8, ["products", "margin-top", "margin-bottom"]))
          ])
        }
      })
    ]), 1032, ["activeTabName", "tabs"]),
    (_unref(selectedTab)?.buttonText && _unref(isMobile))
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: _unref(selectedTab).tabLink,
          class: "products-carousel__header-action"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(selectedTab)?.buttonText), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})